// extracted by mini-css-extract-plugin
export var aiStarIcon = "_cx-4";
export var closeButton = "_cx-6";
export var dismissButton = "_cx-3";
export var editImageWithAiContainer = "_cx-8";
export var imageUploadWrapper = "_cx-7";
export var misspelledWord = "_cx-5";
export var spellCheckContainer = "_cx-2";
export var spin = "_cx-1";
export var spinning = "_cx-0";